import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import type {IRanking, IRankingApiProvider} from "data/providers/api/ranking.api.provider";
import {Bindings} from "data/constants/bindings";

export interface IRankingStore {
	get list(): IRanking[];
	get isNextPage(): boolean;

	resetPageCount(): void;
	fetchLeaderboards(): Promise<void>;
	fetchMoreLeaderboards(): Promise<void>;
}

@injectable()
export class RankingStore implements IRankingStore {
	@observable private _list: IRanking[] = [];
	@observable private _nextPage: boolean = false;
	private _page: number = 0;
	private _limit: number = 30;

	get list(): IRanking[] {
		return this._list;
	}

	get isNextPage() {
		return this._nextPage;
	}
	constructor(@inject(Bindings.RankingApiProvider) private _rankingsApi: IRankingApiProvider) {
		makeAutoObservable(this);
	}

	@action resetPageCount() {
		this._page = 0;
	}

	async fetchLeaderboards() {
		const {
			data: {success},
		} = await this._rankingsApi.ranking({
			page: this._page,
			limit: this._limit,
		});

		runInAction(() => {
			this._list = success.rankings;
			this._nextPage = success.nextPage;
		});
	}

	async fetchMoreLeaderboards() {
		this._page += 1;

		const {
			data: {success},
		} = await this._rankingsApi.ranking({
			page: this._page,
			limit: this._limit,
		});

		runInAction(() => {
			this._list = [...this._list, ...success.rankings];
			this._nextPage = success.nextPage;
		});
	}
}
